import React from 'react';
import PropTypes from 'prop-types';

import SimpleButton from '../SimpleButton';
import LinkButton from '../LinkButton';

import {
  ModalStyled,
  ModalHeaderStyled,
  ModalBodyStyled,
  DescriptionStyled,
  ActionsWrapperStyled
} from './style';

const ConfirmModal = ({
  isOpen,
  toggleHandler,
  title,
  description,
  modalType,
  submitText,
  cancelText,
  onSubmit,
  children
}) => (
  <ModalStyled isOpen={isOpen} toggle={toggleHandler}>
    <ModalHeaderStyled toggle={toggleHandler}>{title}</ModalHeaderStyled>
    <ModalBodyStyled>
      {description && <DescriptionStyled>{description}</DescriptionStyled>}
      {children}
      <ActionsWrapperStyled>
        <LinkButton type="button" onClick={toggleHandler}>
          {cancelText}
        </LinkButton>
        <SimpleButton type="button" onClick={onSubmit} styleMode={modalType}>
          {submitText}
        </SimpleButton>
      </ActionsWrapperStyled>
    </ModalBodyStyled>
  </ModalStyled>
);

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleHandler: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  modalType: PropTypes.string,
  submitText: PropTypes.string,
  cancelText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node
};

ConfirmModal.defaultProps = {
  title: '',
  description: '',
  modalType: '',
  submitText: 'Yes',
  cancelText: 'Cancel',
  children: ''
};

export default ConfirmModal;
